var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "indexed"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.indexed,
      expression: "indexed"
    }],
    staticClass: "icon-container indexed"
  }, [_c('fa', {
    attrs: {
      "icon": "check-circle"
    }
  }), _c('span', [_vm._v("Indexed")])], 1), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.indexed,
      expression: "!indexed"
    }],
    staticClass: "icon-container not-indexed"
  }, [_c('fa', {
    staticClass: "not-indexed-icon",
    attrs: {
      "icon": "exclamation"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.notIndexedLabel,
      expression: "notIndexedLabel"
    }],
    staticClass: "not-indexed"
  }, [_vm._v("Not Indexed")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }